// extracted by mini-css-extract-plugin
module.exports = {"colorBox":"styles__colorBox___3F3ma","icon":"styles__icon___TCnfr"};